module.exports = __webpack_public_path__ + "static/media/puerta11.6ca2db0e.png";